import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

export const UsageReportRowDtoSchema = z.object({
  userId: z.number(),
  fullName: z.string(),
  email: z.email(),
  role: z.string().nullable(),
  organizationName: z.string().nullable(),
  totalDurationSeconds: z.number(),
  sessionsCount: z.number(),
  pageViewsCount: z.number(),
  clicksCount: z.number(),
  lastActiveAt: z.string().nullable(),
});
export type UsageReportRowDto = z.infer<typeof UsageReportRowDtoSchema>;

const GetUsageReportResponseDtoSchema = PagePaginationResponseDtoSchema(
  UsageReportRowDtoSchema
);

export type UsageReportSortField = keyof Pick<
  UsageReportRowDto,
  | 'fullName'
  | 'email'
  | 'role'
  | 'totalDurationSeconds'
  | 'sessionsCount'
  | 'pageViewsCount'
  | 'clicksCount'
  | 'lastActiveAt'
>;

export type GetUsageReportRequestDto = PagePaginationRequestDto<
  {
    from: string;
    to: string;
  },
  UsageReportSortField
>;
export type GetUsageReportResponseDto = z.infer<
  typeof GetUsageReportResponseDtoSchema
>;

export const getUsageReport = (
  params: GetUsageReportRequestDto,
  config?: AxiosRequestConfig<GetUsageReportRequestDto>
) => {
  return api
    .get('/tracking/usage-report', { params, ...config })
    .then(responseContract(GetUsageReportResponseDtoSchema));
};
